// extracted by css-extract-rspack-plugin
export default {"validation":"GkTCPFza95UEzBAZ__validation___","heading":"prFtkXD1dBUimRaF__heading___","formItem":"kkcwu5ZhfjMxR2Mh__formItem___","infoButton":"Nvhrnim2EkAh_vJn__infoButton___"};